Date.fromStr = function(str) {
	let nums = str.split(/[-T:\./\s]/g)
	nums[1] -= 1
	let date = new Date(...nums)
	return date
}

Date.dateFrom = function (string) {
	let long_regex = /(\d{4})([-\/])(\d{2})\2(\d{2})[T\s]?(\d{2}):(\d{2}):(\d{2})/;
	let short_regex = /(\d{4})([-\/])(\d{2})\2(\d{2})/;
    let matchArr = string.match(long_regex) || string.match(short_regex);
    if (matchArr) {
    	let year = matchArr[1],
	        month = parseInt(matchArr[3])-1,
	        day = parseInt(matchArr[4]),
	        hour = matchArr[5] && parseInt(matchArr[5]) || null,
	        minute = matchArr[6] && parseInt(matchArr[6]) || null,
	        second = matchArr[7] && parseInt(matchArr[7]) || null;
	    return new Date(year,month,day,hour,minute,second)
    }
    else {
    	return new Date(string);
    }
    
}